import store from '@/state/store'

export default [
  {
    path: '/',
    name: 'default',
    meta: {
      authRequired: true,
    },
    component: () => import('./views/dashboards/default'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('./views/account/login'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['auth/loggedIn']) {
          next({ name: 'default' })
        } else {
          next()
        }
      },
    },
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('./views/account/register'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['auth/loggedIn']) {
          next({ name: 'default' })
        } else {
          next()
        }
      },
    },
  },
  {
    path: '/forgot-password',
    name: 'Forgot password',
    component: () => import('./views/account/forgot-password'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['auth/loggedIn']) {
          next({ name: 'default' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        localStorage.removeItem('user')
        localStorage.removeItem('token');
        localStorage.removeItem('license');
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.push('/login')
        )
        next(authRequiredOnPreviousRoute ? { name: 'default' } : { ...routeFrom })
      },
    },
  },
  {
    path: '/404',
    component: require('./views/utility/404').default,
  },
  {
    path: '*',
    redirect: '404',
  },
  {
    path: '/newpatient',
    meta: { authRequired: true },
    component: () => import('./views/patients/newpatient')
  },
  {
    path: '/viewpatient',
    meta: { authRequired: true },
    component: () => import('./views/patients/viewpatients')
  }, 
  {
    path: '/appointments',
    meta: { authRequired: true },
    component: () => import('./views/patients/appointments')
  },
  {
    path: '/patientvisits',
    meta: { authRequired: true },
    component: () => import('./views/patients/visits')
  },
  {
    path: '/traige',
    meta: { authRequired: true },
    component: () => import('./views/patients/traige')
  },
  {
    path: '/profile',
    meta: { authRequired: true },
    component: () => import('./views/patients/profile')
  },
  {
    path: '/printprofile',
    meta: { authRequired: true },
    component: () => import('./views/patients/printprofile')
  },
  {
    path: '/consultation',
    meta: { authRequired: true },
    component: () => import('./views/doctor/consultation')
  },
  {
    path: '/procedure',
    meta: { authRequired: true },
    component: () => import('./views/doctor/procedure')
  },
  {
    path: '/dental',
    meta: { authRequired: true },
    component: () => import('./views/doctor/dental')
  },
  {
    path: '/radiology',
    meta: { authRequired: true },
    component: () => import('./views/doctor/radiology')
  },
  {
    path: '/radiologyreport',
    meta: { authRequired: true },
    component: () => import('./views/doctor/radiologyreport')
  },
  {
    path: '/printradiologyreport',
    meta: { authRequired: true },
    component: () => import('./views/doctor/printradiologyreport')
  },
  {
    path: '/antenatal',
    meta: { authRequired: true },
    component: () => import('./views/doctor/antenatal')
  },
  {
    path: '/antenataltreatment',
    meta: { authRequired: true },
    component: () => import('./views/doctor/antenataltreatment')
  },
  {
    path: '/maternity',
    meta: { authRequired: true },
    component: () => import('./views/doctor/maternity')
  },
  {
    path: '/maternitytreatment',
    meta: { authRequired: true },
    component: () => import('./views/doctor/maternitytreatment')
  },
  {
    path: '/theater',
    meta: { authRequired: true },
    component: () => import('./views/doctor/theater')
  },
  {
    path: '/theatertreatment',
    meta: { authRequired: true },
    component: () => import('./views/doctor/theatertreatment')
  },
  {
    path: '/otherservices',
    meta: { authRequired: true },
    component: () => import('./views/doctor/others')
  },
  {
    path: '/treatment',
    meta: { authRequired: true },
    component: () => import('./views/doctor/treatment')
  },
  {
    path: '/printtreatment',
    meta: { authRequired: true },
    component: () => import('./views/doctor/printtreatment')
  },
  {
    path: '/referpatient',
    meta: { authRequired: true },
    component: () => import('./views/doctor/referpatient')
  },
  {
    path: '/dischargepatient',
    meta: { authRequired: true },
    component: () => import('./views/nurse/dischargepatient')
  },
  {
    path: '/inpatients',
    meta: { authRequired: true },
    component: () => import('./views/nurse/inpatients')
  },
  {
    path: '/inpatienttreatment',
    meta: { authRequired: true },
    component: () => import('./views/nurse/inpatienttreatment')
  },
  {
    path: '/picktestsamples',
    meta: { authRequired: true },
    component: () => import('./views/lab/picksamples')
  },
  {
    path: '/entertestresults',
    meta: { authRequired: true },
    component: () => import('./views/lab/entertestresults')
  },
  {
    path: '/testresultreports',
    meta: { authRequired: true },
    component: () => import('./views/lab/testresultreports')
  },
  {
    path: '/testresults',
    meta: { authRequired: true },
    component: () => import('./views/lab/testresults')
  },
  {
    path: '/labresults',
    meta: { authRequired: true },
    component: () => import('./views/lab/labresults')
  },
  {
    path: '/testreport',
    meta: { authRequired: true },
    component: () => import('./views/lab/testreport')
  },
  {
    path: '/printtestreport',
    meta: { authRequired: true },
    component: () => import('./views/lab/printtestreport')
  },
  {
    path: '/labsamples',
    meta: { authRequired: true },
    component: () => import('./views/lab/labsamples')
  },
  {
    path: '/productcategories',
    meta: { authRequired: true },
    component: () => import('./views/pharmacy/productcategories')
  },
  {
    path: '/productunits',
    meta: { authRequired: true },
    component: () => import('./views/pharmacy/productunits')
  },
  {
    path: '/productitemunits',
    meta: { authRequired: true },
    component: () => import('./views/pharmacy/productitemunits')
  },
  {
    path: '/productitems',
    meta: { authRequired: true },
    component: () => import('./views/pharmacy/productitems')
  },
  {
    path: '/sellproduct',
    meta: { authRequired: true },
    component: () => import('./views/pharmacy/sellproduct')
  },
  {
    path: '/sellproductdetails',
    meta: { authRequired: true },
    component: () => import('./views/pharmacy/sellproductdetails')
  },
  {
    path: '/addstock',
    meta: { authRequired: true },
    component: () => import('./views/pharmacy/addstock')
  },
  {
    path: '/stocklevels',
    meta: { authRequired: true },
    component: () => import('./views/pharmacy/stocklevels')
  },
  {
    path: '/reconcilestock',
    meta: { authRequired: true },
    component: () => import('./views/pharmacy/reconcilestock')
  },
  {
    path: '/printreciept',
    meta: { authRequired: true },
    component: () => import('./views/pharmacy/printreciept')
  },
  {
    path: '/suppliers',
    meta: { authRequired: true },
    component: () => import('./views/pharmacy/suppliers')
  },
  {
    path: '/smscenter',
    meta: { authRequired: true },
    component: () => import('./views/smscenter/messages')
  },
  {
    path: '/smspurchase',
    meta: { authRequired: true },
    component: () => import('./views/smscenter/smspurchase')
  },
  {
    path: '/recordexpense',
    meta: { authRequired: true },
    component: () => import('./views/expenses/record')
  },
  {
    path: '/expenseitems',
    meta: { authRequired: true },
    component: () => import('./views/expenses/items')
  },
  {
    path: '/expensecategories',
    meta: { authRequired: true },
    component: () => import('./views/expenses/categories')
  },
  {
    path: '/viewexpenses',
    meta: { authRequired: true },
    component: () => import('./views/expenses/view')
  },
  {
    path: '/viewsavings',
    meta: { authRequired: true },
    component: () => import('./views/finance/viewsavings')
  },
  {
    path: '/accountbalances',
    meta: { authRequired: true },
    component: () => import('./views/finance/accountbalances')
  },
  {
    path: '/patientpayments',
    meta: { authRequired: true },
    component: () => import('./views/finance/payments')
  },
  {
    path: '/ledger',
    meta: { authRequired: true },
    component: () => import('./views/finance/ledger')
  },
  {
    path: '/printinvoice',
    meta: { authRequired: true },
    component: () => import('./views/finance/printinvoice')
  },
  {
    path: '/debtors',
    meta: { authRequired: true },
    component: () => import('./views/finance/debtors')
  },
  {
    path: '/accountinvoices',
    meta: { authRequired: true },
    component: () => import('./views/finance/accountinvoices')
  },
  {
    path: '/groupaccounts',
    meta: { authRequired: true },
    component: () => import('./views/finance/groupaccounts')
  },
  {
    path: '/accountmembers',
    meta: { authRequired: true },
    component: () => import('./views/finance/accountmembers')
  },
  {
    path: '/dispensemedicine',
    meta: { authRequired: true },
    component: () => import('./views/pharmacy/dispensemedicine')
  },
  {
    path: '/birthcertificate',
    meta: { authRequired: true },
    component: () => import('./views/nurse/birthcertificate')
  },
  {
    path: '/printbirthcertificate',
    meta: { authRequired: true },
    component: () => import('./views/nurse/printbirthcertificate')
  },
  {
    path: '/deathcertificate',
    meta: { authRequired: true },
    component: () => import('./views/nurse/deathcertificate')
  },
  {
    path: '/printdeathcertificate',
    meta: { authRequired: true },
    component: () => import('./views/nurse/printdeathcertificate')
  },
  {
    path: '/services',
    meta: { authRequired: true },
    component: () => import('./views/settings/services')
  },
  {
    path: '/paymentoptions',
    meta: { authRequired: true },
    component: () => import('./views/settings/paymentoptions')
  },
  {
    path: '/facilityprofile',
    meta: { authRequired: true },
    component: () => import('./views/settings/profile')
  },
  {
    path: '/diagnosis',
    meta: { authRequired: true },
    component: () => import('./views/settings/diagnosis')
  },
  {
    path: '/roles',
    meta: { authRequired: true },
    component: () => import('./views/users/roles')
  },
  {
    path: '/users',
    meta: { authRequired: true },
    component: () => import('./views/users/users')
  },
  {
    path: '/permissions',
    meta: { authRequired: true },
    component: () => import('./views/users/permissions')
  },
  {
    path: '/audits',
    meta: { authRequired: true },
    component: () => import('./views/users/audits')
  }, 
  {
    path: '/paymentsbyoptionreport',
    meta: { authRequired: true },
    component: () => import('./views/reports/paymentsbyoptionreport')
  }, 
  {
    path: '/paymentsbymonthreport',
    meta: { authRequired: true },
    component: () => import('./views/reports/paymentsbymonthreport')
  },
  {
    path: '/paymentsbyuserreport',
    meta: { authRequired: true },
    component: () => import('./views/reports/paymentsbyuserreport')
  }, 
  {
    path: '/workloadbyuserreport',
    meta: { authRequired: true },
    component: () => import('./views/reports/workloadbyuserreport')
  }, 
  {
    path: '/serviceanalysisreport',
    meta: { authRequired: true },
    component: () => import('./views/reports/serviceanalysisreport')
  }, 
  {
    path: '/departmentanalysisreport',
    meta: { authRequired: true },
    component: () => import('./views/reports/departmentanalysisreport')
  }, 
  {
    path: '/productsdemand',
    meta: { authRequired: true },
    component: () => import('./views/reports/productsdemand')
  }, 
  {
    path: '/cashpaymentsreport',
    meta: { authRequired: true },
    component: () => import('./views/reports/cashpaymentsreport')
  }, 
  {
    path: '/personalpaymentsreport',
    meta: { authRequired: true },
    component: () => import('./views/reports/personalpaymentsreport')
  }, 
  {
    path: '/pharmacypaymentsreport',
    meta: { authRequired: true },
    component: () => import('./views/reports/pharmacypaymentsreport')
  }, 
  {
    path: '/pharmacypurchasereport',
    meta: { authRequired: true },
    component: () => import('./views/reports/pharmacypurchasereport')
  },
  {
    path: '/pharmacybymonthreport',
    meta: { authRequired: true },
    component: () => import('./views/reports/pharmacybymonthreport')
  },
  {
    path: '/purchasebysupplierreport',
    meta: { authRequired: true },
    component: () => import('./views/reports/purchasebysupplierreport')
  }, 
  {
    path: '/labreport',
    meta: { authRequired: true },
    component: () => import('./views/reports/labreport')
  }, 
  {
    path: '/appointmentsreport',
    meta: { authRequired: true },
    component: () => import('./views/reports/appointmentsreports')
  }, 
  {
    path: '/expensesreport',
    meta: { authRequired: true },
    component: () => import('./views/reports/expensesreport')
  }, 
  {
    path: '/cashflowreport',
    meta: { authRequired: true },
    component: () => import('./views/reports/cashflowreport')
  }, 
  {
    path: '/diagnosisanalysisreport',
    meta: { authRequired: true },
    component: () => import('./views/reports/diagnosisanalysisreport')
  }, 
  
]
